import type { ReactNode } from "react";

import { LockIcon } from "lucide-react";
import { useLayoutEffect } from "react";

import FullLogo from "@/assets/login/full-logo-mark.svg?react";

export function CheckoutLayout({ children }: { children: ReactNode }) {
  useForceLightTheme();

  return (
    <div className="min-h-screen bg-bg-secondary">
      <header className="flex h-12 items-center justify-between border-b border-border-secondary bg-bg-primary px-4 md:px-12">
        <FullLogo
          aria-label="NoLimit Creatives"
          className="h-[18px] w-[91px]"
        />
        <div className="flex items-center gap-2 text-sm font-medium text-text-tertiary">
          <LockIcon aria-hidden className="size-[18px]" />
          Secure checkout
        </div>
      </header>
      <main className="mx-auto w-full max-w-[1068px] px-4 pt-6 pb-4 md:pt-12 md:pb-12">
        {children}
      </main>
    </div>
  );
}

// Checkout was only designed in light mode, so the user's dark theme is suspended while it is open.
function useForceLightTheme() {
  useLayoutEffect(() => {
    const root = document.documentElement;
    const wasDark = root.classList.contains("dark");

    root.classList.remove("dark");

    return () => {
      if (wasDark) root.classList.add("dark");
    };
  }, []);
}
